import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/images/my-teams-pro.svg';
const _hoisted_1 = { class: "flex flex-col items-center flex-1 pt-12" };
const _hoisted_2 = { class: "text-4xl font-bold text-center mb-11" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "flex self-stretch justify-end h-40 mt-auto bg-green-300 -z-1" }, [
    /*#__PURE__*/ _createElementVNode("img", {
        src: _imports_0,
        class: "absolute self-end transition-all duration-300 h-60 lg:h-76 bottom-20"
    })
], -1);
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('views.workspaces.seats')
};
import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { useFullWidth } from '@/composables/useFullWidth';
import { useWorkspace } from '@/composables/workspaces';
import Breadcrumb from '@/components/Breadcrumb.vue';
import DeleteSeatsModal from '@/components/workspaces/DeleteSeatsModal.vue';
import Scaffold from '@/components/Scaffold.vue';
import SeatsModifier from '@/components/workspaces/SeatsModifier.vue';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'Seats',
    setup(__props) {
        useFullWidth();
        const store = useStore();
        const router = useRouter();
        const { workspace } = useWorkspace();
        const defaultSeatsToBuy = 0;
        const seatsToBuy = ref(defaultSeatsToBuy);
        const isBuySeatsLoading = ref(false);
        const isDeleteSeatsVisible = ref(false);
        const isBuySeatsDisabled = computed(() => seatsToBuy.value === 0);
        const isFree = computed(() => store.getters.isFreeWorkspace);
        const isOwner = computed(() => store.getters.isWorkspaceOwner);
        const isLoaded = computed(() => !!workspace.value && isOwner.value && !isFree.value);
        async function onBuySeats() {
            isBuySeatsLoading.value = true;
            await store.dispatch('updateWorkspace', {
                seats: workspace.value.seats + seatsToBuy.value,
                workspaceId: workspace.value.id
            });
            isBuySeatsLoading.value = false;
            seatsToBuy.value = defaultSeatsToBuy;
            // Note: This is optimistic but currently we can't detect a failure when
            // calling the `updateWorkspace` action.
            store.dispatch('flashThenClear', { message: 'workspace_seats_updated' });
        }
        watch(workspace, (value) => {
            if (!isOwner.value) {
                router.push({ name: 'showWorkspace', params: { workspaceId: value.id } });
            }
        });
        return (_ctx, _cache) => {
            const _component_PillButton = _resolveComponent("PillButton");
            return (_openBlock(), _createElementBlock("div", null, [
                (_unref(isLoaded))
                    ? (_openBlock(), _createBlock(Scaffold, {
                        key: 0,
                        class: "h-screen pt-10"
                    }, {
                        subheader: _withCtx(() => [
                            _createVNode(Breadcrumb)
                        ]),
                        content: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, [
                                _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('title')), 1),
                                _createVNode(SeatsModifier, {
                                    modelValue: seatsToBuy.value,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((seatsToBuy).value = $event)),
                                    workspace: _unref(workspace),
                                    "fixed-seats-displayed": "available",
                                    "update-total-seats": false
                                }, {
                                    primary: _withCtx(() => [
                                        _createVNode(_component_PillButton, {
                                            onClick: onBuySeats,
                                            loading: isBuySeatsLoading.value,
                                            disabled: _unref(isBuySeatsDisabled)
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('buy')), 1)
                                            ], undefined, true),
                                            _: 1
                                        }, 8, ["loading", "disabled"])
                                    ]),
                                    "fixed-seats-action": _withCtx(() => [
                                        _createElementVNode("button", {
                                            class: "mr-1.5 text-blue-link dark:text-blue-light-link text-sm-but-a-bit-smaller",
                                            onClick: _cache[0] || (_cache[0] = ($event) => (isDeleteSeatsVisible.value = true))
                                        }, _toDisplayString(_ctx.$t('delete')), 1)
                                    ]),
                                    _: 1
                                }, 8, ["modelValue", "workspace"]),
                                _hoisted_3
                            ])
                        ]),
                        "floating-content": _withCtx(() => [
                            _createVNode(DeleteSeatsModal, {
                                "is-visible": isDeleteSeatsVisible.value,
                                "onUpdate:is-visible": _cache[2] || (_cache[2] = ($event) => ((isDeleteSeatsVisible).value = $event))
                            }, null, 8, ["is-visible"])
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
